/**
 * Scroll lock — empêche la page de défiler derrière le panier / les modales.
 *
 * Le thème pose `overflow-hidden` sur <body>, mais Safari iOS ignore
 * `overflow: hidden` sur le body : la page continue de défiler sous le drawer.
 * La seule parade fiable est `position: fixed`, en mémorisant puis en
 * restaurant la position de défilement.
 *
 * On observe la classe posée par le thème plutôt que de patcher son JS : aucun
 * risque de désynchronisation si le thème change sa logique d'ouverture.
 */
(() => {
  const LOCK_CLASS = 'overflow-hidden';
  let scrollY = 0;
  let locked = false;

  const lock = () => {
    if (locked) return;
    locked = true;
    scrollY = window.scrollY;

    const body = document.body;
    body.style.position = 'fixed';
    body.style.top = `-${scrollY}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
  };

  const unlock = () => {
    if (!locked) return;
    locked = false;

    const body = document.body;
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';

    // `position: fixed` remet la page en haut : on restaure la position exacte,
    // sans animation, sinon la remontée est visible.
    window.scrollTo({ top: scrollY, behavior: 'instant' });
  };

  const sync = () => {
    if (document.body.classList.contains(LOCK_CLASS)) {
      lock();
    } else {
      unlock();
    }
  };

  const observer = new MutationObserver(sync);
  observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  sync();
})();
